import { z } from "zod";


export const AuditoriaCopiaSchema = z.object({
    idAuditoria: z.coerce.number(),
    dataAuditoria: z.coerce.date({ invalid_type_error: "Data de recebimento inválida." }),
    evento: z.coerce.string().optional(),

});

export type AuditoriaCopiaForm = z.infer<typeof AuditoriaCopiaSchema>;

export const defaultAuditoriaCopiaForm: Partial<AuditoriaCopiaForm> = {
    dataAuditoria: new Date(),
    evento: "",

}